<mat-icon
  #trigger="cdkOverlayOrigin"
  class="material-icons-outlined"
  cdkOverlayOrigin
  [ngStyle]="style"
  (mouseenter)="show()"
  (mouseleave)="hide()">
  info
</mat-icon>
<ng-template
  cdk-connected-overlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isVisible"
  [cdkConnectedOverlayPositions]="overlayPosition"
  [cdkConnectedOverlayHasBackdrop]="false"
  [cdkConnectedOverlayFlexibleDimensions]="true"
  [cdkConnectedOverlayViewportMargin]="8"
  [cdkConnectedOverlayPush]="true">
  <div
    class="tooltip"
    [class.interactive]="interactive()"
    [class.card]="variant() === 'card'"
    (mouseenter)="show()"
    (mouseleave)="hide()">
    @if (text) {
      <p class="cms-external-content">{{ text | translate }}</p>
    }
    @if (html) {
      <p
        class="cms-external-content"
        [innerHtml]="html"></p>
    }
    @if (template) {
      <ng-template [ngTemplateOutlet]="template"></ng-template>
    }
  </div>
</ng-template>
